/**
 * @file MUI theme wrapper for gem-app entry points.
 * @copyright Copyright (c) 2026 Woolly Bear Software LLC, all rights reserved.
 */
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import React from "react";

import { gemTheme } from "./theme";

export interface AppThemeProviderProps {
  children: React.ReactNode;
}

/** Shared MUI theme + baseline wrapper used by both Vite entry points. */
export function AppThemeProvider({
  children,
}: AppThemeProviderProps): React.ReactElement {
  return (
    <ThemeProvider theme={gemTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
